module.exports = __webpack_public_path__ + "img/gift1.9198f809.png";